function CartReload(data) {
  var container = document.getElementById('cart-table'),
      tT = document.getElementById('total-top'),
      c = document.querySelector('.cart-table'),
      tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top'),
      nC = htmlDocument.documentElement.querySelector('.cart-table'),
      nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);  
  container.querySelector('.full-form').classList.remove('hidden');
  container.querySelector('.empty-form').classList.add('hidden');
  CartButtons();
}

function CartStartReloadFallback() {
  return setTimeout(function() {
    var aB = document.getElementById('ajaxBusy');
    if (aB && getComputedStyle(aB).display != 'none') {
      window.location.href = theme.routes_cart_url;
    }
  }, 8000);
}

function CartStopReloadFallback(timer) {
  if (timer) {
    clearTimeout(timer);
  }
}

function CartNormalizeQuantityInput(iQ) {
  if (!iQ || iQ.value == '') {
    return '';
  }
  var min = parseInt(iQ.getAttribute('min'), 10);
  if (isNaN(min)) {
    min = 0;
  }
  var max = parseInt(iQ.getAttribute('max'), 10);
  var value = Number(iQ.value);
  if (isNaN(value)) {
    value = min;
  }
  value = Math.floor(value);
  if (value < min) {
    value = min;
  }
  if (!isNaN(max) && value > max) {
    value = max;
  }
  iQ.value = value;
  return value;
}

function CartFormatMoney(cents) {
  if (window.Shopify && typeof Shopify.formatMoney == 'function') {
    return Shopify.formatMoney(cents, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
  }
  return '€' + new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100);
}

function CartApplyJsonTotals(j) {
  var header = document.querySelector('header'),
      cC = document.querySelectorAll('.cartCountSelector'),
      cT = document.querySelector('.cartTotalSelector'),
      tT = document.getElementById('total-cart-top'),
      tC = document.getElementById('cart-total'),
      tB = document.getElementById('total-cart-bottom'),
      dC = document.querySelector('.discount-cart');

  cC.forEach(function(c) {
    c.textContent = j.item_count;
  });
  if (header && cT) {
    cT.innerHTML = CartFormatMoney(j.total_price);
  }
  if (tT) {
    tT.innerHTML = CartFormatMoney(j.total_price);
  }
  if (tC && typeof j.original_total_price != 'undefined') {
    tC.innerHTML = CartFormatMoney(j.original_total_price);
  }
  if (dC && j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0) {
    dC.innerHTML = '-' + CartFormatMoney(j.total_discount);
  }
  if (tB) {
    tB.innerHTML = CartFormatMoney(j.total_price);
  }
}

function CartChange(q,container) {
  var header = document.querySelector('header'),
      it = q.closest('.item'),
      id = it.getAttribute('data-product-id'),
      iQ = it.querySelector('.item-qty'),
      q = CartNormalizeQuantityInput(iQ),
      s = it.querySelector('.error'),
      aB = document.getElementById('ajaxBusy'),
      cTa = document.getElementById('cart-table'),
      cC = document.querySelectorAll('.cartCountSelector'),
      cT = document.querySelector('.cartTotalSelector'),
      tT = document.getElementById('total-cart-top'),
      c = document.querySelector('.cart-table'),
      tC = document.getElementById('cart-total'),
      tB = document.getElementById('total-cart-bottom'),
      dC = document.querySelector('.discount-cart'),
      aS = document.querySelector('.animate-section'),
      cD = document.getElementById('cart-dropdown'),
      reloadFallback = null;
  if (q != '') {
    aB.style.display = 'block';
    reloadFallback = CartStartReloadFallback();
  }
  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'quantity': q,'id':id})
  }).then(function(r) {
    return r.json();
  }).then(function(j) {
    if (q != '') {
      CartApplyJsonTotals(j);
    }
    if (j.item_count == 0) {
      ShippingMsg();
      cTa.querySelector('.full-form').classList.add('hidden');
      cTa.querySelector('.empty-form').classList.remove('hidden');
      aB.style.display = 'none';
      CartStopReloadFallback(reloadFallback);
      if (theme.dropdown == true) {
        document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
        document.querySelector('.cart-count-mobile').classList.remove('void');
      }
      if (cD) {
        cD.remove();
      }
    } else {
      var x = theme.cart;
      if (typeof CartDrop == 'function') {
        CartDrop(x);
      }
      document.dispatchEvent(new CustomEvent('cartItems', {
        bubbles: true
      }));
      if (q == 0 && it.isConnected) {
        it.remove();
        fetch((theme.routes_cart_url || '/cart') + '.js', {
          headers: {
            'Accept': 'application/json'
          }
        }).then(function(response) {
          return response.json();
        }).then(CartApplyJsonTotals).catch(function(err) {
          console.error('!: ' + err);
        });
      }
      fetch(theme.routes_cart_url)
      .then(response => response.text())
      .then(data => {
        if (q != '') {
          if (q == 0 && it.isConnected) {
            it.remove();
          }
          CartReload(data)
          aB.style.display = 'none';
          CartStopReloadFallback(reloadFallback);
        }        
      }).catch(function(err) {
        console.error('!: ' + err)
        window.location.href = theme.routes_cart_url;
      });
    };
  }).catch(function(err) {
    console.error('!: ' + err)
    aB.style.display = 'none';
    CartStopReloadFallback(reloadFallback);
    if (q != '') {
      window.location.href = theme.routes_cart_url;
    }
  });
}

function CartButtons() {
  var container = document.getElementById('cart-table');
  if (!container || container.dataset.buddyCartButtonsReady == 'true') {
    return;
  }
  container.dataset.buddyCartButtonsReady = 'true';
  container.addEventListener('click', function(ev) {
    var q = ev.target.closest('.qtybtn');
    if (!q || !container.contains(q)) {
      return;
    }
    ev.preventDefault();
    var fieldName = q.getAttribute('field'),
        iQ = fieldName ? document.getElementById(fieldName) : q.closest('.quantity.form').querySelector('.item-qty');
    if (!iQ) {
      return;
    }
    var currentVal = parseInt(iQ.value, 10) || 0,
        min = parseInt(iQ.getAttribute('min'), 10) || 0,
        max = parseInt(iQ.getAttribute('max'), 10);
    if (q.classList.contains('icon-plus') || q.classList.contains('qtyplus_multi')) {
      if (!isNaN(max) && currentVal >= max) {
        return;
      }
      iQ.value = currentVal + 1;
    } else if (q.classList.contains('icon-minus') || q.classList.contains('qtyminus_multi')) {
      iQ.value = Math.max(min, currentVal - 1);
    } else if (q.classList.contains('remove_item_multi')) {
      iQ.value = 0;
    }
    CartChange(q,container);
  });
  container.addEventListener('keyup', function(ev) {
    var q = ev.target.closest('.item-qty');
    if (!q || !container.contains(q) || ev.key == 'Tab' || ev.key == 'Shift') {
      return;
    }
    clearTimeout(q.buddyCartTimeout);
    q.buddyCartTimeout = setTimeout(function () {
      CartChange(q,container);
    }, 750);
  });
}

function CartDiscountBridge(container) {
  if (!container || container.dataset.buddyDiscountBridgeReady == 'true') {
    return;
  }
  container.dataset.buddyDiscountBridgeReady = 'true';
  var discountBridgeApplying = false,
      discountBridgeApplyingCode = '';

  function resetDiscountBridge() {
    discountBridgeApplying = false;
    discountBridgeApplyingCode = '';
  }

  function cartRedirectPath() {
    var params = new URLSearchParams();
    try {
      var current = new URL(window.location.href);
      if (current.searchParams.has('preview_theme_id')) {
        params.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      }
    } catch (err) {
      console.error('!: ' + err);
    }
    params.set('buddy_discount_applied', Date.now());
    return (theme.routes_cart_url || '/cart') + '?' + params.toString();
  }

  function currentLiveDiscountCode() {
    var discountInput = container.querySelector('#total-bottom [data-live-discount] input[name="discount"], #total-bottom [data-live-discount] input[type="text"], #total-bottom [data-live-discount] input');
    return discountInput && discountInput.value ? discountInput.value.trim() : '';
  }

  function cartHasDiscountCode(code) {
    return fetch((theme.routes_cart_url || '/cart') + '.js', {
      headers: {
        'Accept': 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) {
        return false;
      }
      return response.json();
    }).then(function(cart) {
      var applications = cart.cart_level_discount_applications || [];
      return applications.some(function(application) {
        return application.title && application.title.toLowerCase() == code.toLowerCase();
      });
    });
  }

  function applyLiveDiscountCode(code) {
    code = code || currentLiveDiscountCode();
    if (!code || (discountBridgeApplying && discountBridgeApplyingCode == code)) {
      return;
    }
    discountBridgeApplying = true;
    discountBridgeApplyingCode = code;
    cartHasDiscountCode(code).then(function(isApplied) {
      if (isApplied) {
        resetDiscountBridge();
        return;
      }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartRedirectPath());
      setTimeout(resetDiscountBridge, 4500);
    }).catch(function(err) {
      console.error('!: ' + err);
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartRedirectPath());
      setTimeout(resetDiscountBridge, 4500);
    });
  }

  container.addEventListener('click', function(ev) {
    if (ev.target.closest('#total-bottom [data-live-discount] button')) {
      var clickedCode = currentLiveDiscountCode();
      setTimeout(function() {
        applyLiveDiscountCode(clickedCode);
      }, 1200);
      setTimeout(function() {
        applyLiveDiscountCode(clickedCode);
      }, 2600);
    }
  });

  var observer = new MutationObserver(function() {
    applyLiveDiscountCode();
  });
  observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
  applyLiveDiscountCode();
}

theme.CartPage = (function() {
  function CartPage(container) {
    if (container.dataset.buddyCartPageReady == 'true') {
      return;
    }
    container.dataset.buddyCartPageReady = 'true';
    var sectionId = container.getAttribute('data-section-id'),
        chk = container.getAttribute('data-check'),
        acb = container.querySelector('.additional-checkout-buttons');
    theme.cart = true;
    if(chk == 'true'){      
      var cT = document.getElementById('cart-terms');
      var checkoutText = 'Zur Kasse gehen';
      function syncCartTerms() {
        var nC = container.querySelector('[name="checkout"]');
        if (!cT || !nC) {
          return;
        }
        if (cT.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', checkoutText);
          nC.value = checkoutText;
          nC.textContent = checkoutText;
          if (acb) {
            acb.classList.remove('hidden');
          }
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', checkoutText);
          nC.value = checkoutText;
          nC.textContent = checkoutText;
          if (acb) {
            acb.classList.add('hidden');
          }
        }
      }
      if (cT) {
        var syncAttempts = 0,
            syncInterval = setInterval(function() {
              syncAttempts += 1;
              syncCartTerms();
              if (syncAttempts >= 20 || cT.checked == true) {
                clearInterval(syncInterval);
              }
            }, 500);
        cT.onclick = syncCartTerms;
        cT.onchange = syncCartTerms;
        syncCartTerms();
        setTimeout(syncCartTerms, 250);
        setTimeout(syncCartTerms, 1500);
      }
    };
    CartButtons(container);
    CartDiscountBridge(container);
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();

(function() {
  function initCartPage() {
    var container = document.querySelector('[data-section-type="cart_page"]');
    if (container && theme.CartPage) {
      new theme.CartPage(container);
    }
  }
  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }
})();
